
export const CACHE_TYPE = {
    // user
    CACHE_USER_INFO: 'CACHE_USER_INFO', //用户详情
    CACHE_LOGINTOKEN: 'CACHE_LOGINTOKEN', //loginToken
    CACHE_LIVETOKEN: 'CACHE_LIVETOKEN', //liveToken
};

const _setItem = (key, value)=>{
  window.localStorage.setItem(key, value);
}

const _getItem = (key, defaultValue) => {
  let str = window.localStorage.getItem(key);
  if(str) {
    return str;
  } else {
    return defaultValue;
  }
};

const _getItemParse = (key) => {
  let str = window.localStorage.getItem(key);
  if(str) {
    return JSON.parse(str);
  } else {
    return '';
  }
};

const _setSessionItem = (key, value)=>{
  window.sessionStorage.setItem(key, value);
}

const _getSessionItem = (key, defaultValue) => {
  let str = window.sessionStorage.getItem(key);
  if(str) {
    return str;
  } else {
    return defaultValue;
  }
};

const _getSessionItemParse = (key) => {
  let str = window.sessionStorage.getItem(key);
  if(str) {
    return JSON.parse(str);
  } else {
    return '';
  }
};

/**
 * ==================================================================
 * */

//用户详细信息
export const setUserInfo = (userInfo) => {
    _setSessionItem(CACHE_TYPE.CACHE_USER_INFO,JSON.stringify(userInfo))
};
export const getUserInfo = () => {
    return _getSessionItemParse(CACHE_TYPE.CACHE_USER_INFO)
};


//LoginToken
export const setLoginToken = (loginToken) => {
  _setSessionItem(CACHE_TYPE.CACHE_LOGINTOKEN, loginToken)
};
export const getLoginToken = () => {
  return _getSessionItem(CACHE_TYPE.CACHE_LOGINTOKEN)
};
